module.exports = __webpack_public_path__ + "img/num03.a08950b8.png";